<template>
  <div class="box">
    <!-- 头部 -->
    <headers></headers>
    <el-carousel :interval="3000">
      <el-carousel-item>
        <img src="@/assets/homePage/ja-banner.png" class="images">
      </el-carousel-item>
    </el-carousel>
    <!-- 内容 -->
    <div class="content">
      <div class="region">
        <h3>勤務地:</h3>
        <p v-for="item in jobDate" :key="item.id">
        <p :class="['p_1', { 'p_Btn': item.id == id }]" @click="pBtn(item.id)">{{ item.name }}</p>
        <!-- <el-button type="primary" round plain> </el-button> -->
        </p>
      </div>
      <div class="job">
        <h3>募集職種:</h3>
        <div class="info" v-for="item in engineerList" :key="item.id" @click="IdBtn(item.id)">
          <div class="info_1">{{ item.name }}</div>
          <div class="info_2">
            <el-icon>
              <component :is="item.id == dataId ? 'Minus' : 'Plus'"></component>
              <!-- <Plus v-if='item.id!=dataId'/>
              <SemiSelect v-else  @click="SemiSelectBtn"/> -->
            </el-icon>
          </div>
          <div class="info_3" v-show="item.id == dataId">
            <h3>職務内容</h3>
            <p v-for="e in item.child_1" :key="e.id">{{ e.title }}</p>
            <h3>{{ item.requirement }}</h3>
            <p v-for="e in item.child_2" :key="e.id">{{ e.title }}</p>
            <h3>{{ item.recruitment }}</h3>
            <p>{{ item.headcount }}人</p>
            <h3>{{ item.location }}</h3>
            <div style="width:100%;text-align: left;">
              <span v-for="(e,index) in item.locationList" :key="e.id"
                style="text-align:left;display: inline-block;margin-left: 0;">{{ index == (item.locationList.length-1) ? e.title:e.title+'、'}}</span>
            </div>
            <h3>問い合わせ先</h3>
            <p>{{item.Email}}</p>
            <a class="p_1" :href="email">履歴提出</a>
          </div>
        </div>

      </div>
    </div>

    <!-- 底部 -->
    <foot></foot>
  </div>
  <div class="_div">
    <!-- 头部 -->
    <move_header></move_header>
    <!-- 轮播图 -->
    <van-swipe :autoplay="3000" indicator-color="white">
      <van-swipe-item>
        <img src="@/assets/homePage/ja-banner.png" class="images">
      </van-swipe-item>
    </van-swipe>
    <!-- 中间内容区域 -->
    <div class="content_center">
      <p v-for="item in jobDate" :key="item.id" @click="pBtn(item.id)" :class="[{ 'p_move': item.id == id }]">
        {{ item.name }}</p>
      <div class="info" v-for="item in engineerList" :key="item.id" @click="IdBtn(item.id)">
        <span class="span_1">{{ item.name }}</span>
        <span class="span_2">
          <el-icon>
            <component :is="item.id == dataId ? 'Minus' : 'Plus'"></component>
            <!-- <Plus v-if='item.id!=dataId'/>
                    <SemiSelect v-else  @click="SemiSelectBtn"/> -->
          </el-icon>
        </span>
        <div class="span_3" v-show="item.id == dataId">
          <h3>職務内容</h3>
          <p style="width: 100%;" v-for="e in item.child_1" :key="e.id">{{ e.title }}</p>
          <h3>{{ item.requirement }}</h3>
          <p style="width: 100%;" v-for="e in item.child_2" :key="e.id">{{ e.title }}</p>
          <h3>{{ item.recruitment }}</h3>
          <p style="text-align: center;">{{ item.headcount }}人</p>
          <h3>{{ item.location }}</h3>
          <div style="width:100%;text-align: left;">
            <span v-for="(e,index) in item.locationList" :key="e.id"
              style="font-size: 2.8rem;">{{ index == (item.locationList.length-1) ? e.title:e.title+'、'}}</span>
          </div>
          <h3>問い合わせ先</h3>
           <p>{{item.Email}}</p>
          <a class="p_1" :href="email">履歴提出</a>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <move_foot></move_foot>
  </div>
</template>

<script>
import foot from '../components/foot.vue'
import headers from '../components/header.vue'
import move_foot from "../move_components/move_foot.vue";
import move_header from "../move_components/move_header.vue";
import { reactive, toRefs, watch } from 'vue'
export default {
  components: { foot, headers, move_foot, move_header },
  computed: {
    icons: function () {
      return () => {

      }
    }
  },
  setup() {

    const state = reactive({
      id: 1,
      dataId: 0,
      isIcon: 'Plus',
      email: 'mailto:shuyu.zhu@shine-optics.com',
      jobDate: [
        { id: 1, name: '重慶' },
        { id: 2, name: '江西' },
        { id: 3, name: '深セン' },
        { id: 4, name: 'インド' },
      ],
      engineerList: [
        { id: 1,Email:'shuyu.zhu@shine-optics.com',name: 'プロダクトマネージャー', requirement: '必要な経験等', recruitment: '採用人数', headcount: 3, location: "勤務地", child_1: [{ id: 1, title: "1.会社の発展戦略と計画によって、会社の医療、AIOT、車のネットワークなどの知能映像、レンズモジュールのハードウェア製品の設計を主導します。" }, { id: 2, title: "2.ユーザー/顧客のニーズ、市場調査、競合製品分析、製品計画、製品機能の設計など" }, { id: 3, title: "3.適切な製品サプライヤの調査、選定、統合、ハードウェアの研究開発の調整、外部リソースとの連携による製品開発、テスト、試作、および量産プロセスの推進" }, { id: 4, title: "4.製品の量産に関わるサプライチェーン、品質管理の一環をコントロールし、量産中の問題を解決します" }, { id: 5, title: "5.市場ニーズとビジネスニーズの調査分析、および製品設計、プロセス設計、またプロトタイプ作成を行い、特許ベースのドキュメントを出力" }, { id: 6, title: "6.定期的に競争品に対して業界追跡分析を行い、業界の動態をタイムリーに把握し、建設的な製品アイデアを提案します" }, { id: 7, title: "7.ユーザーの意見を収集し、製品のユーザーエクスペリエンスを継続的に最適化し、製品の改善のための反復パスを作成します" }], child_2: [{ id: 1, title: "1.大卒以上の学歴、電子関連専攻、英語力良好" }, { id: 2, title: "2.5年以上の車載/医療映像/知能IoT/知能ウェアラブル/ノートパソコンなど、任意の1つの製品プロジェクトの経験があり、関連製品のPRD設計を主導し、実際に製品の全過程の管理に参与したことがあります。" }, { id: 3, title: "3.総合素質能力が優秀で、例えば、コミュニケーション協調能力、革新能力、データ分析能力、論理思考能力、抗圧能力など。" }], locationList: [{ id: 1, title: '重慶' }, { id: 2, title: '深セン' }, { id: 3, title: '江西' }] },
        { id: 2,Email:'shuyu.zhu@shine-optics.com',name: 'プロジェクトマネジメント', requirement: '必要な経験等', recruitment: '採用人数', headcount: 2, location: "勤務地", child_1: [{ id: 1, title: "1、新しいプロジェクトのレビューを主導 " }, { id: 2, title: "2、プロジェクトサンプル作成の進捗管理を担当" },{id:3,title:"サンプル、試作品の材料生産及び出荷進度を担当し、出荷の達成を保証します"},{id:4,title:"組織プロジェクトの進行審査を担当する"},{id:5,title:"プロジェクトの技術資料、ファイル資料のアーカイブを担当します"},{id:6,title:"プロジェクトチームメンバーのパフォーマンスレビューを主導します"}], child_2: [{ id: 1, title: "1.大卒学歴、電子、機械、自動化などの専門;" }, { id: 2, title: "2.家電業界のPM業務経験2年以上;" }, { id: 3, title: "3.部門を超えた資源調整と問題推進に優れています" }, { id: 4, title: '4. プロジェクト管理、工場管理に対する成熟したシステム認識を持ち、プロセス改善に長けています' }, { id: 5, title: '5.車載カメラ/ノートパソコンのカメラ/テレビの外付けカメラ/携帯電話のカメラなどの項目を熟知している経験者が優先' }], locationList: [{ id: 1, title: '重慶' }] },

      ]
    })
    watch(() => state.isIcon, (count, prevCount) => {

    })
    let methods = {
      pBtn(id) {
        state.id = id
        state.dataId = 0
        if (id == 1) {
          state.email = 'mailto:shuyu.zhu@shine-optics.com'
          state.engineerList = [
         { id: 1,Email:'shuyu.zhu@shine-optics.com',name: 'プロダクトマネージャー', requirement: '必要な経験等', recruitment: '採用人数', headcount: 3, location: "勤務地", child_1: [{ id: 1, title: "1.会社の発展戦略と計画によって、会社の医療、AIOT、車のネットワークなどの知能映像、レンズモジュールのハードウェア製品の設計を主導します。" }, { id: 2, title: "2.ユーザー/顧客のニーズ、市場調査、競合製品分析、製品計画、製品機能の設計など" }, { id: 3, title: "3.適切な製品サプライヤの調査、選定、統合、ハードウェアの研究開発の調整、外部リソースとの連携による製品開発、テスト、試作、および量産プロセスの推進" }, { id: 4, title: "4.製品の量産に関わるサプライチェーン、品質管理の一環をコントロールし、量産中の問題を解決します" }, { id: 5, title: "5.市場ニーズとビジネスニーズの調査分析、および製品設計、プロセス設計、またプロトタイプ作成を行い、特許ベースのドキュメントを出力" }, { id: 6, title: "6.定期的に競争品に対して業界追跡分析を行い、業界の動態をタイムリーに把握し、建設的な製品アイデアを提案します" }, { id: 7, title: "7.ユーザーの意見を収集し、製品のユーザーエクスペリエンスを継続的に最適化し、製品の改善のための反復パスを作成します" }], child_2: [{ id: 1, title: "1.本科及以上学历，电子相关专业，英语能力良好；" }, { id: 2, title: "2.五年以上车载/医疗影像/智能物联网/智能穿戴/笔电等产品其中的任意一种产品项目经验，主导过相关产品PRD设计，实际参与过产品的全生命周期管理；" }, { id: 3, title: "3.综合素质能力优秀，如沟通协调能力、创新能力、数据分析能力、逻辑思维能力、抗压能力等。" }], locationList: [{ id: 1, title: '重庆' }, { id: 2, title: '深圳' }, { id: 3, title: '江西' }] },
        { id: 2,Email:'shuyu.zhu@shine-optics.com',name: 'プロジェクトマネジメント', requirement: '必要な経験等', recruitment: '採用人数', headcount: 1, location: "勤務地", child_1: [{ id: 1, title: "1、新しいプロジェクトのレビューを主導 " }, { id: 2, title: "2、プロジェクトサンプル作成の進捗管理を担当" },{id:3,title:"サンプル、試作品の材料生産及び出荷進度を担当し、出荷の達成を保証します"},{id:4,title:"組織プロジェクトの進行審査を担当する"},{id:5,title:"プロジェクトの技術資料、ファイル資料のアーカイブを担当します"},{id:6,title:"プロジェクトチームメンバーのパフォーマンスレビューを主導します"}], child_2: [{ id: 1, title: "1.大卒学歴、電子、機械、自動化などの専門;" }, { id: 2, title: "2.家電業界のPM業務経験2年以上;" }, { id: 3, title: "3.部門を超えた資源調整と問題推進に優れています" }, { id: 4, title: '4. プロジェクト管理、工場管理に対する成熟したシステム認識を持ち、プロセス改善に長けています' }, { id: 5, title: '5.車載カメラ/ノートパソコンのカメラ/テレビの外付けカメラ/携帯電話のカメラなどの項目を熟知している経験者が優先' }], locationList: [{ id: 1, title: '重慶' }] },

          ]
        } else if (id == 2) {
          state.email = 'mailto:ruifang.liu@shine-optics.com'
          state.engineerList = [
            { id: 1,Email:'ruifang.liu@shine-optics.com', name: 'プロダクトマネージャー', requirement: '必要な経験等', recruitment: '採用人数', headcount: 3, location: "勤務地", child_1: [{ id: 1, title: "1.会社の発展戦略と計画によって、会社の医療、AIOT、車のネットワークなどの知能映像、レンズモジュールのハードウェア製品の設計を主導します。" }, { id: 2, title: "2.ユーザー/顧客のニーズ、市場調査、競合製品分析、製品計画、製品機能の設計など" }, { id: 3, title: "3.適切な製品サプライヤの調査、選定、統合、ハードウェアの研究開発の調整、外部リソースとの連携による製品開発、テスト、試作、および量産プロセスの推進" }, { id: 4, title: "4.製品の量産に関わるサプライチェーン、品質管理の一環をコントロールし、量産中の問題を解決します" }, { id: 5, title: "5.市場ニーズとビジネスニーズの調査分析、および製品設計、プロセス設計、またプロトタイプ作成を行い、特許ベースのドキュメントを出力" }, { id: 6, title: "6.定期的に競争品に対して業界追跡分析を行い、業界の動態をタイムリーに把握し、建設的な製品アイデアを提案します" }, { id: 7, title: "7.ユーザーの意見を収集し、製品のユーザーエクスペリエンスを継続的に最適化し、製品の改善のための反復パスを作成します" }], child_2: [{ id: 1, title: "1.大卒以上の学歴、電子関連専攻、英語力良好" }, { id: 2, title: "2.5年以上の車載/医療映像/知能IoT/知能ウェアラブル/ノートパソコンなど、任意の1つの製品プロジェクトの経験があり、関連製品のPRD設計を主導し、実際に製品の全過程の管理に参与したことがあります。" }, { id: 3, title: "3.総合素質能力が優秀で、例えば、コミュニケーション協調能力、革新能力、データ分析能力、論理思考能力、抗圧能力など。" }], locationList: [{ id: 1, title: '重慶' }, { id: 2, title: '江西' }, { id: 3, title: '深セン' }] },
       ]
        } else if (id == 3) {
          state.email = 'mailto:shuyu.zhu@shine-optics.com'
          state.engineerList = [
            { id: 1,Email:'shuyu.zhu@shine-optics.com', name: 'プロダクトマネージャー', requirement: '必要な経験等', recruitment: '採用人数', headcount: 3, location: "勤務地", child_1: [{ id: 1, title: "1.会社の発展戦略と計画によって、会社の医療、AIOT、車のネットワークなどの知能映像、レンズモジュールのハードウェア製品の設計を主導します。" }, { id: 2, title: "2.ユーザー/顧客のニーズ、市場調査、競合製品分析、製品計画、製品機能の設計など" }, { id: 3, title: "3.適切な製品サプライヤの調査、選定、統合、ハードウェアの研究開発の調整、外部リソースとの連携による製品開発、テスト、試作、および量産プロセスの推進" }, { id: 4, title: "4.製品の量産に関わるサプライチェーン、品質管理の一環をコントロールし、量産中の問題を解決します" }, { id: 5, title: "5.市場ニーズとビジネスニーズの調査分析、および製品設計、プロセス設計、またプロトタイプ作成を行い、特許ベースのドキュメントを出力" }, { id: 6, title: "6.定期的に競争品に対して業界追跡分析を行い、業界の動態をタイムリーに把握し、建設的な製品アイデアを提案します" }, { id: 7, title: "7.ユーザーの意見を収集し、製品のユーザーエクスペリエンスを継続的に最適化し、製品の改善のための反復パスを作成します" }], child_2: [{ id: 1, title: "1.大卒以上の学歴、電子関連専攻、英語力良好" }, { id: 2, title: "2.5年以上の車載/医療映像/知能IoT/知能ウェアラブル/ノートパソコンなど、任意の1つの製品プロジェクトの経験があり、関連製品のPRD設計を主導し、実際に製品の全過程の管理に参与したことがあります。" }, { id: 3, title: "3.総合素質能力が優秀で、例えば、コミュニケーション協調能力、革新能力、データ分析能力、論理思考能力、抗圧能力など。" }], locationList: [{ id: 1, title: '重慶' }, { id: 2, title: '江西' }, { id: 3, title: '深セン' }] },
  

          ]
        } else if (id == 4) {
          state.engineerList = [
            { id: 1,Email:'shuyu.zhu@shine-optics.com', name: 'IEエンジニア', requirement: '必要な経験等', recruitment: '採用人数', headcount: 1, location: "勤務地", child_1: [{ id: 1, title: '1.生産現場の標準労働時間、標準作業、価値流、生産配置、作業最適化、管理プロセス最適化などの改善作業を担当します' }, { id: 2, title: "2.プロジェクトの効率改善、品質改善案の調査、制定に参加し、関連専門案の実行を担当" }, { id: 3, title: '3.生産管理制度、プロセスの作成、最適化と実施推進を担当します' }, { id: 4, title: "4.生産・運営に関する改善課題の検討、プログラムの設計・実行への参与" }, { id: 5, title: '5.指導者の一時的な手配に従います' }], child_2: [{ id: 1, title: '1.大卒学歴、工業エンジニアリング関連専攻' }, { id: 2, title: '2.少なくとも1年間の機械加工業界の経験' }, { id: 3, title: "3.リーン生産、現場効率改善、生産運営の実際の仕事の経験があります" }, { id: 4, title: '4.一定のプロジェクト計画、組織管理、コミュニケーション協調能力を持っています' }, { id: 5, title: "5.Office/CADなどのオフィスソフトウェアの応用に精通しており、自動化、設備、プロセス機器について一定の知識を持っています" }, { id: 6, title: "6.英語を聞く、話す、読む、書く能力が良好で、海外派遣などを受けることができます" }], locationList: [{ id: 1, title: "インド" }] },
            { id: 2,Email:'shuyu.zhu@shine-optics.com', name: 'EOL PEエンジニア', requirement: '必要な経験等', recruitment: '採用人数', headcount: 1, location: "勤務地", child_1: [{ id: 1, title: '1.プロセスの最適化と製品の良品率/自動化設備の直通改善' }, { id: 2, title: "2.ジョブの標準化管理、文書の編集および作成" }, { id: 3, title: '3.作業員訓練および審査認定' }, { id: 4, title: "4.生産ラインの異常分析/客訴分析、重工方案の処理" }, { id: 5, title: '5.プロセス最適化' },{id:6,title:'プロジェクト改善/6 sigmaプロジェクト改善推進'},{id:7,title:"各部門の資源を調整し、日常業務の展開に有利になります"},{id:8,title:"顧客監査事項および事項を協力して完成させます"}], child_2: [{ id: 1, title: '1.大卒学歴、工業エンジニアリング関連専攻' }, { id: 2, title: '2.少なくとも1年間の機械加工業界の経験' }, { id: 3, title: "3.リーン生産、現場効率改善、生産運営の実際の仕事の経験があります" }, { id: 4, title: '4.一定のプロジェクト計画、組織管理、コミュニケーション協調能力を持っています' }, { id: 5, title: "5.Office/CADなどのオフィスソフトウェアの応用に精通しており、自動化、設備、プロセス機器について一定の知識を持っています" }, { id: 6, title: "6.英語を聞く、話す、読む、書く能力が良好で、海外派遣などを受けることができます" }], locationList: [{ id: 1, title: "インド" }] },
          ],
          state.email = 'mailto:shuyu.zhu@shine-optics.com'
        }
      },
      IdBtn(id) {
        state.dataId = id
      },
      SemiSelectBtn() {
        state.dataId = 0
      }
    }
    return {
      ...toRefs(state), ...methods
    }
  }
}

</script>

<style scoped lang="less">
.el-carousel {
  max-width: 1920px;
  margin: 0 auto;
}

.p_1 {
  display: block;
  margin: 0 auto;
  text-indent: 0 !important;
  font-size: 20px;
  text-align: center;
  width: 170px;
  height: 42px;
  border: 1px solid #ccc;
  line-height: 42px;
  cursor: pointer;
}

.p_1:hover {
  color: #fff !important;
  background-color: #ef3e2e;
}

.p_Btn {
  color: #fff !important;
  background-color: #ef3e2e;
}

.box {
  width: 100%;

  .content {
    display: flex;
    margin: 0 auto;
    width: 70%;
    min-height: 100px;
    max-width: 1920px;

    .region {

      margin: 10px 0;
      flex: 1;

      p {
        text-indent: 1em;
      }

      p:hover {
        color: #ef3e2e
      }
    }

    .job {
      margin: 10px 0;
      margin-left: 30px;
      flex: 6;

      .info {
        position: relative;
        cursor: pointer;
        min-height: 80px;
        border: 1px solid #ccc;
        margin: 10px 0;
        text-align: center;
        line-height: 80px;

        .info_1 {
          text-align: left;
          font-weight: 500;
          margin-left: 30px;
        }

        .info_2 {
          font-size: 30px;
          position: absolute;
          top: 0;
          right: 30px;
          text-align: right;
          color: #ef3e2e;
          cursor: pointer;
        }

        .info_3 {
          padding-top: 10px;
          height: auto;
          background-color: #eee;
          line-height: 20px;
          padding-bottom: 16px;
          cursor: default;
          div {
            margin-left: 30px;
          }

          h3 {
            text-align: left;
            margin-left: 30px;
          }

          .p_1 {
            text-align: center;
            margin-top: 30px;
            margin-left: 30px;
            text-decoration: none;
            color: black;
          }

          p {
            margin: 0;
            padding: 0;
            text-align: left;
            margin-left: 30px;
            min-height: 40px;
            line-height: 35px;
          }
        }
      }
    }
  }
}

::v-deep .el-carousel {
  max-width: 1920px;
  margin: 0 auto;
  overflow-y: hidden;
  height: auto;
  max-height: 600px;
  // max-height: 700px;
}

::v-deep .el-carousel__container {
  height: 100% !important;
  min-height: 500px;
}

.el-carousel {
  max-width: 1920px;
  margin: 0 auto;
}

::v-deep .el-card {
  border-radius: 8px;
}

.images {
  width: 100%;
  height: 60autovh;
  max-height: 600px;
}

// 小屏幕区域
@media only screen and (min-width: 767px) {
  .box {
    display: block;
  }

  ._div {
    display: none;
  }
}

@media only screen and (max-width: 767px) {
  .box {
    display: none;
  }

  ._div {
    display: block;



    .content_center {
      padding: 30px;
      text-align: center;

      p {
        display: inline-block;
        margin-left: 50px;
        font-size: 70px;
        font-weight: 600;
        cursor: pointer;
        user-select: none;
      }

      .p_move {
        border-bottom: 8px solid #ef3e2e;
      }

      .info {
        width: 100%;
        height: auto;
        border: 1px solid #ccc;
        margin: 50px 0;
        min-height: 250px;
        cursor: pointer;

        .span_1,
        .span_2 {
          font-size: 60px;
          line-height: 250px;
        }

        .span_1 {
          float: left;
          margin-left: 100px;
        }

        .span_2 {
          float: right;
          font-size: 90px;
          margin-right: 100px;
          cursor: pointer;
          color: #ef3e2e;
        }

        .span_3 {
          background-color: #eee;
          margin-top: 230px;
          text-align: left;
          padding:  0 30px;
          box-sizing: border-box;
          padding-bottom: 30px;
          cursor: default;

          h3 {
            font-size: 60px;
            padding-top: 80px;
            text-align: center;
          }

          p {
            font-size: 45px;
            margin: 10px 0;
            text-align: left;
            font-weight: 400;
          }

          a {
            text-align: center;
            // margin-top: 30px;
            // margin-left: 30px;
            font-size: 60px;
            width: 450px;
            height: 120px;
            line-height: 120px;
            border: 1px solid #ccc;
            text-decoration: none;
            color: black;
            margin-top: 10px;
            padding-bottom: 10px;
            box-sizing: border-box;
          }
        }
      }
    }
  }
}
</style>